import { useEffect, useState } from 'react';
import { isBackendOnline, isBackendOnlineSync } from '../utils/backendStatus.ts';

interface ConnectivityStatus {
  isOnline: boolean;
  isBackendOnline: boolean;
  backendChecked: boolean;
}

export function useConnectivityStatus(): ConnectivityStatus {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isBackendOnlineState, setIsBackendOnlineState] = useState(isBackendOnlineSync());
  const [backendChecked, setBackendChecked] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const updateBackendStatus = async () => {
      if (!navigator.onLine) {
        if (isMounted) {
          setIsBackendOnlineState(false);
          setBackendChecked(true);
        }
        return;
      }
      const backendOnline = await isBackendOnline();
      if (isMounted) {
        setIsBackendOnlineState(backendOnline);
        setBackendChecked(true);
      }
    };

    const handleOnline = () => {
      setIsOnline(true);
      updateBackendStatus();
    };
    const handleOffline = () => {
      setIsOnline(false);
      setIsBackendOnlineState(false);
      setBackendChecked(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    updateBackendStatus();

    const interval = window.setInterval(() => {
      if (navigator.onLine) {
        updateBackendStatus();
      }
    }, 15000);

    return () => {
      isMounted = false;
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      window.clearInterval(interval);
    };
  }, []);

  return { isOnline, isBackendOnline: isBackendOnlineState, backendChecked };
}
